import type { LockedFolder } from "@/components/core/FileManager";

export const SYSTEM_TAG_APPROVED = "approved";
export const ORIGIN_TAG_PREFIX = "org:";
export const APPROVED_FOLDER_NAME = "Approved to share with client";
export const PHOTOS_AND_DOCUMENTS_FOLDER_NAME = "Photos & Documents";

const MAX_TAG_LENGTH = 50;
const MAX_ORIGIN_NAME_LENGTH = MAX_TAG_LENGTH - ORIGIN_TAG_PREFIX.length;

export function isSystemTag(name: string): boolean {
  return name === SYSTEM_TAG_APPROVED || name.startsWith(ORIGIN_TAG_PREFIX);
}

export function isApprovedFolderName(name: string | null | undefined): boolean {
  return name === APPROVED_FOLDER_NAME;
}

export function buildOriginTag(folderName: string): string {
  const safe = folderName.slice(0, MAX_ORIGIN_NAME_LENGTH);
  return `${ORIGIN_TAG_PREFIX}${safe}`;
}

export function parseOriginTag(name: string): { folderName: string } | null {
  if (!name.startsWith(ORIGIN_TAG_PREFIX)) return null;
  const folderName = name.slice(ORIGIN_TAG_PREFIX.length);
  if (!folderName) return null;
  return { folderName };
}

export const WO_LOCKED_FOLDERS: LockedFolder[] = [
  { name: "AP", rootOnly: true, disallow: ["move", "rename", "delete"] },
  { name: APPROVED_FOLDER_NAME, rootOnly: true, disallow: ["move", "rename", "delete"] },
  { name: "AR", rootOnly: true, disallow: ["move", "rename", "delete"] },
  { name: "Client-provided documents", rootOnly: true, disallow: ["move", "rename", "delete"] },
  { name: "QA", rootOnly: true, disallow: ["move", "rename", "delete"] },
  { namePrefix: "Visit", rootOnly: true, disallow: ["move", "rename", "delete"] },
  {
    name: PHOTOS_AND_DOCUMENTS_FOLDER_NAME,
    rootOnly: true,
    disallow: ["move", "rename", "delete"],
  },
];

// Mirrors the client-default-folders automation rule in the backend. The names
// must match, or a renamed folder here would be recreated on the next client.
export const CLIENT_LOCKED_FOLDERS: LockedFolder[] = [
  { name: "Contracts & agreements", rootOnly: true, disallow: ["move", "rename", "delete"] },
  { name: "Insurance & compliance", rootOnly: true, disallow: ["move", "rename", "delete"] },
  { name: "Rates & pricing", rootOnly: true, disallow: ["move", "rename", "delete"] },
];
